import React, { useEffect, useState } from 'react';
import propTypes from 'prop-types';
import styled from 'styled-components';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { StyledButton } from '../../../../Components/Generics.styled';

const WhenShouldAdRunContainer = styled.div`
    display: flex;
    height: 400px;
    align-items: center;
    flex-direction: column;
`;

const Title = styled.div`
    margin-top: 100px;

    font-size: 23px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    height: 50px;
    flex-direction: column;
    font-weight: bold;
    text-align: center;
`;

const StyledNavButtons = styled.div`
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 160px;
    margin-left: auto;
    margin-right: auto;
`;

const DatePickerContainer = styled.div`
    height: 70px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;

    .MuiOutlinedInput-root {
        background-color: #fafbf7;
    }
`;

const WhenShouldAdRun = (props) => {
    const {
        campaignData,
        setCampaignData,
        handleNavButtonBack,
        handleNavButtonNext,
        setPageIndex,
    } = props;
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const futureDateInvalid = dayjs(endDate).isBefore(startDate);

    const dateisInvalid = startDate === '' || endDate === '' || futureDateInvalid;

    useEffect(() => {
        if (startDate && endDate) {
            setCampaignData({
                ...campaignData,
                startDate: startDate.toISOString(),
                endDate: endDate.toISOString(),
            });
        }
    }, [startDate, endDate]);

    useEffect(() => {
        if (campaignData.startDate !== '' && campaignData.endDate !== '') {
            setStartDate(dayjs(campaignData.startDate));
            setEndDate(dayjs(campaignData.endDate));
        }
    }, [campaignData.startDate, campaignData.endDate]);

    const aWeekFromToday = dayjs().add(7, 'day');
    const validFutureDates = dayjs(startDate).add(1, 'day');

    const isGoogle = campaignData?.campaignTypeId === 1;

    const handleNavButtonNextSkipUpload = () => {
        setPageIndex(6);
    };

    const determineRoute = () => {
        if (isGoogle) {
            return handleNavButtonNextSkipUpload();
        }

        return handleNavButtonNext();
    };

    return (
        <WhenShouldAdRunContainer>
            <Title>When should your Ad run?</Title>
            <DatePickerContainer>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        value={startDate}
                        minDate={aWeekFromToday}
                        disablePast
                        onChange={(newValue) => {
                            setStartDate(newValue);
                        }}
                    />
                    <div style={{ marginLeft: '10px', marginRight: '10px' }}>to</div>
                    <DatePicker
                        value={endDate}
                        minDate={validFutureDates}
                        onChange={(newValue) => {
                            setEndDate(newValue);
                        }}
                    />
                </LocalizationProvider>
            </DatePickerContainer>

            {futureDateInvalid ? (
                <div style={{ color: 'red' }}>End date cannot be before start date.</div>
            ) : null}

            <StyledNavButtons>
                <StyledButton
                    variant="contained"
                    color="primary"
                    onClick={() => handleNavButtonBack()}
                >
                    Back
                </StyledButton>
                <StyledButton
                    variant="contained"
                    color="primary"
                    onClick={() => determineRoute()}
                    disabled={dateisInvalid}
                >
                    Next
                </StyledButton>
            </StyledNavButtons>
        </WhenShouldAdRunContainer>
    );
};

WhenShouldAdRun.propTypes = {
    campaignData: propTypes.shape({
        startDate: propTypes.string,
        endDate: propTypes.string,
        campaignTypeName: propTypes.string,
        campaignTypeId: propTypes.number,
    }),
    setCampaignData: propTypes.func,
    handleNavButtonNext: propTypes.func,
    handleNavButtonBack: propTypes.func,
    setPageIndex: propTypes.func,
};

WhenShouldAdRun.defaultProps = {
    campaignData: {},
    setCampaignData: () => {},
    handleNavButtonNext: () => {},
    handleNavButtonBack: () => {},
    setPageIndex: () => {},
};
export default WhenShouldAdRun;
